import useLoadVehicles from './functions/useLoadVehicles';
import useSearches from './functions/useSearches';
import useDeleteVehicle from './functions/useDeleteVehicle';
import useQrCodes from './functions/useQrCodes';

export default function useVehicles() {
  const {
    userProfile,
    isLoadLoading,
    companyCode,
    vehicles,
    apiFetched,
    handleTryAgain,
    roles,
    selectedCompany,
    loadVehicles,
  } = useLoadVehicles();

  const {
    filteredVehicles,
    handleChangeSearchTerm,
    searchTerm,
  } = useSearches({ vehicles });

  const {
    vehicleBeingDeleted,
    deleteModalShow,
    setDeleteModalShow,
    isDeleting,
    deleteVehicle,
    handleOpenDeleteVehicleModal,
  } = useDeleteVehicle({ loadVehicles });

  const {
    vehicleQrCodeBeingShow,
    vehicleQrCodeModalShow,
    isDownloadingQrCode,
    allQrCodesModalShow,
    areQrCodesDownloading,
    downloadAllQrCodes,
    downloadQrCode,
    handleOpenVehicleQrCodeModal,
    setAllQrCodesModalShow,
    setVehicleQrCodeModalShow,
    allQrCodesRef,
    qrCodeRef,
  } = useQrCodes();

  const isLoading = isLoadLoading || isDeleting;

  return {
    userProfile,
    isLoading,
    companyCode,
    vehicles,
    apiFetched,
    searchTerm,
    handleChangeSearchTerm,
    filteredVehicles,
    setAllQrCodesModalShow,
    handleTryAgain,
    allQrCodesModalShow,
    roles,
    areQrCodesDownloading,
    downloadAllQrCodes,
    handleOpenVehicleQrCodeModal,
    handleOpenDeleteVehicleModal,
    vehicleBeingDeleted,
    deleteModalShow,
    setDeleteModalShow,
    vehicleQrCodeBeingShow,
    vehicleQrCodeModalShow,
    setVehicleQrCodeModalShow,
    companyName: selectedCompany.label,
    allQrCodesRef,
    qrCodeRef,
    isDownloadingQrCode,
    downloadQrCode,
    deleteVehicle,
  };
}
